import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import companyLogo from "../../assets/images/HR360_Logo.png";
import navLinksMenu from "../Sidebar/navLinksMenu";
import navLinksOther from "../Sidebar/navLinksOther";

const Sidebar = ({ userData }) => {
  const permissions = JSON.parse(localStorage.getItem("userPermissions"));
  const [activeMenuMain, setActiveMenuMain] = useState(null);
  const [activeMenuOther, setActiveMenuOther] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleMenuMain = (menuIndex) => {
    if (navLinksMenu[menuIndex].title === "Employee Salary") {
      setActiveMenuMain(activeMenuMain === menuIndex ? null : menuIndex);
    } else {
      setActiveMenuMain(activeMenuMain === menuIndex ? null : menuIndex);
      setActiveMenuOther(null);
    }
  };

  const toggleMenuOther = (menuIndex) => {
    setActiveMenuOther(activeMenuOther === menuIndex ? null : menuIndex);
    setActiveMenuMain(null);
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

 const allowedPermissions = [
  "view_per_group_all_employees_info",
  "view_all_managed_employees_info"
];

const hasViewOtherMenu = permissions?.some((permission) =>
  allowedPermissions.includes(permission?.name)
);

  // Filter main menu items based on permissions
  const filteredNavLinksMenu = navLinksMenu.filter(item => {
    if (item.title === "Payroll Management" || item.title === "Exit Management" || item.title === "Leave Management") {
      return hasViewOtherMenu;
    }
    return true;
  });

  return (
    <div className={`fixed top-0 left-0 h-full z-50 bg-white overflow-y-auto transition-all duration-300 ${isExpanded ? 'w-64' : 'w-16'} md:w-64 py-3`}>
      <div className="flex items-center justify-between h-16 px-4">
        <img
          src={companyLogo}
          alt="Company Logo"
          className={`w-44 ${isExpanded ? 'block' : 'hidden'} md:block my-4`}
        />
        <button
          onClick={toggleSidebar}
          className="md:hidden text-gray-600 focus:outline-none"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isExpanded ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
            />
          </svg>
        </button>
      </div>

      <div className="mt-6 px-2">
        <div className="menu">
          <ul className="flex flex-col gap-2">
            <h5 className={`text-sm font-semibold ${isExpanded ? 'block' : 'hidden'} md:block`}>MAIN MENU</h5>
            {filteredNavLinksMenu.map((item, index) => (
              <li key={index}>
                {item.children ? (
                  <Link
                    className={`flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${activeMenuMain === index ? 'bg-green-100 text-green-600' : ''}`}
                    onClick={() => toggleMenuMain(index)}
                  >
                    <i className={`${item.icon} text-xl`}></i>
                    <span className={`${isExpanded ? 'block' : 'hidden'} md:block`}>{item.title}</span>
                  </Link>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${isActive || activeMenuMain === index ? 'bg-green-100 text-green-600' : ''}`
                    }
                    onClick={() => toggleMenuMain(index)}
                  >
                    <i className={`${item.icon} text-xl`}></i>
                    <span className={`${isExpanded ? 'block' : 'hidden'} md:block whitespace-nowrap`}>{item.title}</span>
                  </NavLink>
                )}

                {item.children && (
                  <ul
                    className={`ml-5 mt-2 flex flex-col gap-2 ${activeMenuMain === index && isExpanded ? 'block' : 'hidden'} md:${activeMenuMain === index ? 'block' : 'hidden'}`}
                  >
                    {item.children.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <NavLink
                          to={subItem.path}
                          className={({ isActive }) =>
                            `flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${isActive ? 'bg-green-100 text-green-600' : ''}`
                          }
                        >
                          <i className={`${subItem.icon} text-xl`}></i>
                          <span className={`${isExpanded ? 'block' : 'hidden'} md:block`}>{subItem.title}</span>
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          {hasViewOtherMenu && (
            <ul className="flex flex-col gap-2 mt-8">
              <h5 className={`text-sm font-semibold ${isExpanded ? 'block' : 'hidden'} md:block`}>OTHER</h5>
              {navLinksOther.map((item, index) => (
                <li key={index}>
                  {item.children ? (
                    <Link
                      className={`flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${activeMenuOther === index ? 'bg-green-100 text-green-600' : ''}`}
                      onClick={() => toggleMenuOther(index)}
                    >
                      <i className={`${item.icon} text-xl`}></i>
                      <span className={`${isExpanded ? 'block' : 'hidden'} md:block whitespace-nowrap`}>{item.title}</span>
                    </Link>
                  ) : (
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${isActive || activeMenuOther === index ? 'bg-green-100 text-green-600' : ''}`
                      }
                      onClick={() => toggleMenuOther(index)}
                    >
                      <i className={`${item.icon} text-xl`}></i>
                      <span className={`${isExpanded ? 'block' : 'hidden'} md:block`}>{item.title}</span>
                    </NavLink>
                  )}

                  {item.children && (
                    <ul
                      className={`ml-5 mt-2 flex flex-col gap-2 ${activeMenuOther === index && isExpanded ? 'block' : 'hidden'} md:${activeMenuOther === index ? 'block' : 'hidden'}`}
                    >
                      {item.children.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <NavLink
                            to={subItem.path}
                            className={({ isActive }) =>
                              `flex items-center gap-2 text-gray-700 hover:text-green-600 p-2 rounded-md ${isActive ? 'bg-green-100 text-green-600' : ''}`
                            }
                          >
                            <i className={`${subItem.icon} text-xl`}></i>
                            <span className={`${isExpanded ? 'block' : 'hidden'} md:block`}>{subItem.title}</span>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;